import { CalendarClock, X } from 'lucide-react';
import { useT } from '../hooks/useT';
import { datumKort } from '../utils/datum';
import type { KaartStaat } from '../utils/kaart';

interface KaartHerinneringProps {
  staat: Extract<KaartStaat, { soort: 'geldig' | 'verlopen' }>;
  /** Hoogte van de zwevende kop, zodat de herinnering eronder verschijnt. */
  bovenMarge: number;
  onBekijk: () => void;
  onSluit: () => void;
}

/** Korte herinnering onder de kop als je Museumkaart binnenkort verloopt (of al verlopen is). */
export function KaartHerinnering({ staat, bovenMarge, onBekijk, onSluit }: KaartHerinneringProps) {
  const { t, tf, language } = useT();
  const tekst =
    staat.soort === 'verlopen'
      ? tf('herinneringVerlopen', { datum: datumKort(staat.verval, language) })
      : staat.dagen === 0
        ? t('herinneringVandaag')
        : staat.dagen === 1
          ? t('herinneringMorgen')
          : tf('herinneringBinnenkort', { n: staat.dagen });

  return (
    <div className="pointer-events-none fixed inset-x-0 z-20 px-3 sm:px-4" style={{ top: bovenMarge + 8 }}>
      <div
        role="status"
        className="pointer-events-auto mx-auto flex max-w-xl items-center gap-2 rounded-2xl bg-amber-100/95 py-1.5 pl-4 pr-1.5 text-amber-950 shadow-lg backdrop-blur-md dark:border dark:border-white/10 dark:bg-amber-950/90 dark:text-amber-100"
      >
        <CalendarClock size={18} className="shrink-0" aria-hidden />
        <p className="min-w-0 flex-1 text-sm font-semibold leading-snug">{tekst}</p>
        <button
          onClick={onBekijk}
          className="min-h-11 whitespace-nowrap rounded-xl bg-white/60 px-3 text-sm font-semibold transition-all duration-150 active:scale-95 dark:bg-slate-900/50"
        >
          {t('herinneringBekijk')}
        </button>
        <button
          onClick={onSluit}
          aria-label={t('herinneringSluit')}
          className="grid h-11 w-11 shrink-0 place-items-center rounded-xl transition-all duration-150 active:scale-95"
        >
          <X size={18} aria-hidden />
        </button>
      </div>
    </div>
  );
}
